module.exports = __webpack_public_path__ + "f98a63d7c124c8ec412cc388fd53aac1.png";